import React, { useState } from 'react';
import { Building2, ChevronDown, CircleDot, Flag, Plus, Store } from 'lucide-react';
import './customFieldTable.css';

const customFields = [
  {
    id: 'department',
    label: 'Department',
    fieldLabel: 'Department - Finance',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Payroll', 'Recruitment', 'Hardware'],
  },
  {
    id: 'priorities',
    label: 'Priorities',
    fieldLabel: 'Priorities',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Low', 'Medium', 'High'],
  },
  {
    id: 'statuses',
    label: 'Statuses',
    fieldLabel: 'Statuses',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Open', 'In Progress', 'Closed'],
  },
  {
    id: 'storeId',
    label: 'Store ID',
    fieldLabel: 'Store ID',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Store 101', 'Store 102', 'Store 103'],
  },
];

const fieldIcons = {
  department: Building2,
  priorities: Flag,
  statuses: CircleDot,
  storeId: Store,
};

export default function CustomFieldTable({ onAddField }) {
  const [open, setOpen] = useState(false);

  return (
    <aside className={`custom-field-table${open ? ' is-open' : ''}`} aria-labelledby="custom-field-table-title">
      <button
        type="button"
        className="custom-field-table__summary"
        aria-expanded={open}
        aria-controls="custom-field-table-list"
        onClick={() => setOpen((current) => !current)}
      >
        <span className="custom-field-table__summary-text">
          <span id="custom-field-table-title" className="custom-field-table__title">
            Custom Fields
          </span>
          <span className="custom-field-table__description">
            Use these fields to show options from database table.
          </span>
        </span>
        <ChevronDown className="custom-field-table__chevron" size={16} strokeWidth={1.8} aria-hidden="true" />
      </button>

      <div id="custom-field-table-list" className="custom-field-table__list">
        {customFields.map((field) => {
          const FieldIcon = fieldIcons[field.id];
          return (
            <div className="custom-field-table__row" key={field.id}>
              <FieldIcon className="custom-field-table__field-icon" size={14} strokeWidth={1.5} aria-hidden="true" />
              <span className="custom-field-table__label">{field.label}</span>
              <button
                className="custom-field-table__add"
                type="button"
                aria-label={`Add ${field.label}`}
                title={`Add ${field.label}`}
                onClick={() => onAddField?.(field)}
              >
                <Plus size={14} strokeWidth={2} aria-hidden="true" />
              </button>
            </div>
          );
        })}
      </div>
    </aside>
  );
}